/* eslint-disable max-len */
export const VALID_APPLIANCE_TYPES = [
  'REFRIGERATOR',
  'FRIDGE',
  'LAUNDRY',
  'WASHER',
  'DRYER',
  'ALL-IN-ONE'
];

export const WIDGET_MAPPING = {
  REFRIGERATOR: {
    PIP: {
      header: 'Make Sure It Fits Your Space',
      subtext: 'Learn how to measure for easy installation',
      canHaveArrow: false,
      hasInitialBackArrow: false,
      isPip: true
    },
    PLP: {
      header: 'Find Refrigerators That Fit Your Home',
      subtext: 'Measure your space to help you narrow down what works.',
      canHaveArrow: true,
      hasInitialBackArrow: false,
      isPlp: true
    },
    MINI: {
      header: 'Make sure it will fit',
      hasInitialBackArrow: true,
      isMini: true
    },
  },
  LAUNDRY: {
    PIP: {
      header: 'Make Sure It Fits Your Space',
      subtext: 'Learn how to measure for easy installation',
      canHaveArrow: false,
      hasInitialBackArrow: false,
      isPip: true
    },
    PLP: {
      header: 'Find a Washer & Dryer That Fit Your Home',
      subtext: 'Measure your space to help you narrow down what works.',
      canHaveArrow: true,
      hasInitialBackArrow: false,
      isPlp: true
    },
    MINI: {
      header: 'Make sure it will fit',
      hasInitialBackArrow: true,
      isMini: true
    },
  }
};

export const TYPE_LIST = ['PIP', 'PLP', 'MINI'];

export const ANIMATIONS = {
  FOUR_EASY_STEPS: 'https://dam.thdstatic.com/content/production/HCH7BLdVbBDlRaSKb4669g/zFblzMgkby-QRMCgmsQRkg/Original%20file/d29a-major-appliance-delivery-ux--first-page-animation-1224.gif',
  DELIVERY_PATH: 'https://dam.thdstatic.com/content/production/XB_IEIRYwATswFPkUxKwgA/F_UW0OcaF8A47YFOoIGvEQ/Original%20file/d29a-major-appliance-delivery-ux---refrigerator-delivery-path---500px-0824.gif',
  REFRIGERATOR_MEASURE_WIDTH: 'https://dam.thdstatic.com/content/production/rEQpLV7muxt2wVAEGWHCBQ/anC0JuGFBzxJ8Cn-_FK35g/Original%20file/d29a-major-appliance-delivery-ux---refrigerator-measure-width---500px-0724.gif',
  REFRIGERATOR_MEASURE_HEIGHT: 'https://dam.thdstatic.com/content/production/2dmhK03g_srKintsykd5nw/3XJW5XvfKo6bc8akdthW8w/Original%20file/d29a-major-appliance-delivery-ux---refrigerator-measure-height---500px-0824.gif',
  REFRIGERATOR_MEASURE_DEPTH: 'https://dam.thdstatic.com/content/production/yqN0_mtdwvV_fwZKusNtJw/oZJplEVCKVsj4nbn76OtDA/Original%20file/d29a-major-appliance-delivery-ux---refrigerator-measure-depth---500px-0724.gif',
  REFRIGERATOR_DOOR_CHECK: 'https://dam.thdstatic.com/content/production/W80wzNV4gKJhwJyKoy_A5Q/uoQglKkckmdyMqd_VZlyBA/Original%20file/d29a-major-appliance-delivery-ux---refrigerator-door-check---500px-0824.gif',
};

export const IMAGES = {
  REFRIGERATOR_STANDARD_DEPTH: 'https://dam.thdstatic.com/content/production/2f9oz_QDxF--uDl7LPpKVQ/CSbZHaYnTK79SHaEAHaKJA/Original%20file/d29a-major-appliance-delivery-ux--refrigerator-standard-depth---500px-0824.png',
  REFRIGERATOR_COUNTER_DEPTH: 'https://dam.thdstatic.com/content/production/jiONqGsSsPuwQurWePx6JQ/I_RV2C5QYQ5ErlJ7M7m_Xg/Original%20file/d29a-major-appliance-delivery-ux--refrigerator-counter-depth---500px-0824.png'
};

export const REFRIGERATOR_MAPPING = [
  // Page 1
  {
    header: 'Make Sure It Fits',
    sections: [
      {
        text: {
          id: 'text_0',
          string: 'Let\'s Measure Your Space In Four Easy Steps',
          isTitle: true
        }
      },
      {
        text: {
          id: 'text_1',
          string: 'Accurate measurements will ensure a perfect fit for your new refrigerator. You\'ll need a tape measure and be ready to take notes.'
        }
      },
      {
        image: {
          id: 'image_1',
          src: ANIMATIONS.FOUR_EASY_STEPS,
          alt: 'Four Easy Steps',
          size: '100%'
        }
      },
      {
        tip: {
          id: 'tip_0',
          string: 'You\'re not measuring your old refrigerator. Focus on the space it will be installed and clear a path for delivery.'
        },
        modifiers: {
          hasBorder: true
        }
      },
      {
        text: {
          id: 'text_2',
          string: 'Need help measuring? Please call your local store for more information.'
        }
      }
    ],
    footer: 'Next'
  },
  // Page 2
  {
    header: 'Step 1 of 4',
    sections: [
      {
        text: {
          id: 'text_3',
          string: 'Map Your Delivery Path',
          isTitle: true
        }
      },
      {
        text: {
          id: 'text_4',
          string: 'We want delivery and installation to go easy for you.'
        }
      },
      {
        text: {
          id: 'text_5',
          string: 'Our experts suggest:'
        },
        modifiers: {
          marginOverride: 2
        }
      },
      {
        list: {
          id: 'list_0',
          items: [
            'Find a route with the least obstacles from the delivery truck to the installation location.',
            'Measure your front door, interior doors, hallways and tight spaces along this path.',
            'Take note of the narrowest gap and tight turns.'
          ]
        }
      },
      {
        image: {
          id: 'image_2',
          src: ANIMATIONS.DELIVERY_PATH,
          alt: 'Delivery Path',
          size: '100%'
        }
      },
      {
        text: {
          id: 'text_6',
          string: 'This will help you know if your refrigerator will clear the delivery path.'
        }
      },
      {
        tip: {
          id: 'tip_1',
          string: 'If your refrigerator is a few inches too big for delivery, we can remove the handles for clearance.'
        },
        modifiers: {
          hasBorder: true
        }
      }
    ],
    footer: 'Next'
  },
  // Page 3
  {
    header: 'Step 2 of 4',
    sections: [
      {
        text: {
          id: 'text_7',
          string: 'Measure the Width',
          isTitle: true
        }
      },
      {
        text: {
          id: 'text_8',
          string: 'In the space where your refrigerator will go, take note of the width in three places:'
        },
        modifiers: {
          marginOverride: 2
        }
      },
      {
        list: {
          id: 'list_1',
          items: [
            'the upper cabinet',
            'the counter top',
            'the base levels'
          ]
        },
      },
      {
        text: {
          id: 'text_9',
          string: 'Use the smallest measurement of the three.'
        }
      },
      {
        image: {
          id: 'image_3',
          src: ANIMATIONS.REFRIGERATOR_MEASURE_WIDTH,
          alt: 'Refrigerator Measure Width',
          size: '100%'
        }
      },
      {
        tip: {
          id: 'tip_2',
          string: 'Leave a minimum of 1/8-inch on both sides of the refrigerator for ventilation. If your refrigerator is located next to a wall, leave 4 1/2-inch between the wall and the hinge side of the door so it can swing open.'
        },
        modifiers: {
          hasBorder: true
        }
      },
      {
        text: {
          id: 'text_10',
          string: 'Standard refrigerators are 28 3/4-inches - 39 3/4 inches wide.',
          isTiny: true
        }
      }
    ],
    footer: 'Next'
  },
  // Page 4
  {
    header: 'Step 3 of 4',
    sections: [
      {
        text: {
          id: 'text_11',
          string: 'Measure the Height',
          isTitle: true
        }
      },
      {
        text: {
          id: 'text_12',
          string: 'Measure from the floor to the lowest point of the top of  your fridge space. Do this in both the front and back of the space.'
        }
      },
      {
        text: {
          id: 'text_13',
          string: 'Use the shorter of these two measurements for height.'
        },
        modifiers: {
          marginOverride: 6
        }
      },
      {
        image: {
          id: 'image_4',
          src: ANIMATIONS.REFRIGERATOR_MEASURE_HEIGHT,
          alt: 'Refrigerator Measure Height',
          size: '100%'
        }
      },
      {
        tip: {
          id: 'tip_3',
          string: 'Leave a minimum of 1-inch gap from the top to leave space. Why?',
          sections: [
            {
              list: {
                id: 'list_2',
                items: [
                  'Make room for the refrigerator door hinge to operate freely',
                  'Proper ventilation improves performance and efficiency'
                ]
              },
              modifiers: {
                marginOverride: 0
              }
            }
          ]
        },
        modifiers: {
          hasBorder: true
        }
      },
      {
        text: {
          id: 'text_14',
          string: 'Standard refrigerators are 61 3/4-inches - 71 3/4 inches high.',
          isTiny: true
        }
      }
    ],
    footer: 'Next'
  },
  // Page 5
  {
    header: 'Step 4 of 4',
    sections: [
      {
        text: {
          id: 'text_15',
          string: 'Decide on Depth',
          isTitle: true
        }
      },
      {
        text: {
          id: 'text_16',
          string: 'Measure the depth from the back wall to the front edge of your counters.'
        }
      },
      {
        image: {
          id: 'image_5',
          src: ANIMATIONS.REFRIGERATOR_MEASURE_DEPTH,
          alt: 'Refrigerator Measure Depth',
          size: '100%'
        }
      },
      {
        tip: {
          id: 'tip_4',
          string: 'Leave a minimum of 2-inches from the back wall for ventilation.'
        },
        modifiers: {
          hasBorder: true
        }
      },
      {
        text: {
          id: 'text_17',
          string: 'You have two options - standard-depth and counter-depth refrigerators.'
        },
        modifiers: {
          marginOverride: 2
        }
      },
      [
        [
          {
            list: {
              id: 'list_3',
              items: [
                'Standard-depth refrigerators extend about 6-inches past the front of the counters.'
              ]
            }
          },
          {
            text: {
              id: 'text_18',
              string: 'Standard refrigerators are 28 3/4-inches - 34 5/8-inches deep.',
              isTiny: true
            },
            modifiers: {
              shiftLeft: true,
              marginOverride: 4
            }
          }
        ],
        [
          {
            list: {
              id: 'list_4',
              items: [
                'Counter-depth refrigerators will fit flush with your kitchen counter tops.'
              ]
            }
          },
          {
            text: {
              id: 'text_19',
              string: 'Standard counter-depth refrigerators are 24 inches 30 inches deep.',
              isTiny: true
            },
            modifiers: {
              shiftLeft: true,
              marginOverride: 4
            }
          },
        ]
      ],
      {
        sections: {
          id: 'sections_0',
          items: [
            {
              image: {
                id: 'image_6',
                src: IMAGES.REFRIGERATOR_STANDARD_DEPTH,
                alt: 'Refrigerator Standard Depth',
                size: '100%',
                subHeader: 'Standard Depth'
              },
              modifiers: {
                hasBorder: true
              }
            },
            {
              image: {
                id: 'image_7',
                src: IMAGES.REFRIGERATOR_COUNTER_DEPTH,
                alt: 'Refrigerator Counter Depth',
                size: '100%',
                subHeader: 'Counter Depth'
              },
              modifiers: {
                hasBorder: true
              }
            }
          ]
        },
        modifiers: {
          marginOverride: 8,
          flexGroup: true
        }
      },
      {
        text: {
          id: 'text_20',
          string: 'Make sure there\'s enough space in front of the fridge for kitchen cabinets and drawers to fully open.'
        }
      },
      {
        image: {
          id: 'image_8',
          src: ANIMATIONS.REFRIGERATOR_DOOR_CHECK,
          alt: 'Refrigerator Door Check',
          size: '100%'
        },
        modifiers: {
          marginOverride: 0
        }
      }
    ],
    footer: 'Done'
  }
];

// LAUNDRY CONSTANTS

export const LAUNDRY_ANIMATIONS = {
  FIVE_EASY_STEPS: 'https://dam.thdstatic.com/content/production/HCH7BLdVbBDlRaSKb4669g/zFblzMgkby-QRMCgmsQRkg/Original%20file/d29a-major-appliance-delivery-ux--first-page-animation-1224.gif',
  DELIVERY_PATH: 'https://dam.thdstatic.com/content/production/ABjJIN6pg980yH4aYZOgYA/Qt5wGeIiHy4vbVwKgjT3CQ/Original%20file/7321000-d29a-step-1-full-delivery-path-laundry-500x500.gif',
  SIDE_BY_SIDE_WIDTH: 'https://dam.thdstatic.com/content/production/9AswAkSfjR4KWAlSi3DLvQ/rLpTKcnzWf-yCjdQDCkHMg/Original%20file/7321000-d29a-step-3a-side-by-side-width-500x500.gif',
  SIDE_VIEW: 'https://dam.thdstatic.com/content/production/_3Qr9M04orvmtB4eSjrQbQ/EbuLSW0fdPWoGbQkFDwRQA/Original%20file/7321000-d29a-step-4a-door-height-check-500x500.gif',
  SIDE_BY_SIDE_HEIGHT: 'https://dam.thdstatic.com/content/production/gIKcXY-YRh3f6OLMzrMZ8Q/C09Odkkvu6CuXbLC2s1yyQ/Original%20file/7321000-d29a-step-4b-side-by-side-height-500x500.gif',
  STACKED_WIDTH: 'https://dam.thdstatic.com/content/production/TsVI6tOuiy9MbOfUk26j7Q/6EvujOE3esbO0PMXdj283Q/Original%20file/7321000-d29a-step-3b-stacked-width-500x500.gif',
  STACKED_HEIGHT: 'https://dam.thdstatic.com/content/production/H01P2oNTDfanxW0IO09HOw/3cHiKtRxD_7ji2mMHUuq0A/Original%20file/7321000-d29a-step-4c-stacked-height-500x500.gif',
  DEPTH: 'https://dam.thdstatic.com/content/production/cD1H50DZrjiQIzOZZwqSjQ/q7w1KRYaRxo0kmxARTLMYA/Original%20file/7321000-d29a-step-5a-laundry-room-depth-500x500.gif',
  SWING_DEPTH: 'https://dam.thdstatic.com/content/production/wSEVvgFgGKP2trZAF5EFgw/4GFlwJaMKOj76Bsv1bN7pA/Original%20file/7321000-d29a-step-5b-doors-open-500x500.gif'
};

export const LAUNDRY_IMAGES = {
  THREE_PRONG: 'https://dam.thdstatic.com/content/production/VTz6k37-p5lS2vFpC3hQeQ/KFNoqXVGVmiH7fx2T3-7eA/Original%20file/7321000-d29a-dryer-outlet-240-volt-3-prong_05-08-2025.svg',
  FOUR_PRONG: 'https://dam.thdstatic.com/content/production/zmT-6Itws71fRxamKRxz0w/x51hmNyepJopin663wEFZA/Original%20file/7321000-d29a-oven-outlet-125-250-volt-4-prong_05-08-2025.svg',
  GAS: 'https://dam.thdstatic.com/content/production/dS1LjuiGlHK3PpPb7n4KoA/fI2aJx_uv-oLOVOB2TX_Tg/Original%20file/7321000-d29a-gas-valve-v3.svg',
  ELECTRIC: 'https://dam.thdstatic.com/content/production/SobKqOHiNAp4DkDxpnUsDg/AvcBm6ZXoJNvXD09z9GJMg/Original%20file/7321000-d29a-outlet-120-volt-3-prong-v3.svg',
  SIDE_BY_SIDE: 'https://dam.thdstatic.com/content/production/01tWtDJoGViR61CM4qiyKw/onBi0F8qGxgpC3a-7RmVpw/Original%20file/7321000-d29a-side-by-side-washer-dryer_05-08-2025.svg',
  SIDE_BY_SIDE_WITH_PEDESTALS: 'https://dam.thdstatic.com/content/production/MWX9m59LxzYNqJ8AawcHGg/RM1Y0RQgO31dmwWtQ1phiA/Original%20file/7321000-d29a-washer-dryer-drawers_05-08-2025.svg',
  STACKED: 'https://dam.thdstatic.com/content/production/rNiIaZDgv6eQMI9YIXBTBQ/UPIRIpN7QAwAwyjjuQ5Glg/Original%20file/7321000-d29a-stacked-washer-dryer_05-08-2025.svg',
};

export const LAUNDRY_DRAWER_MAPPING = [
  // Page 1
  {
    header: 'Make Sure It Fits',
    sections: [
      {
        text: {
          id: 'text_0',
          string: 'Let\'s Measure Your Space In Five Easy Steps',
          isTitle: true
        }
      },
      {
        text: {
          id: 'text_1',
          string: 'Accurate measurements will ensure a perfect fit for your new washer and dryer. You\'ll need a tape measure and be ready to take notes.'
        }
      },
      {
        image: {
          id: 'image_1',
          src: LAUNDRY_ANIMATIONS.FIVE_EASY_STEPS,
          alt: 'Four Easy Steps',
          size: '100%'
        }
      },
      {
        tip: {
          id: 'tip_0',
          string: 'You\'re not measuring your old washer and dryer. Focus on the space it will be installed and clear a path for delivery.'
        },
        modifiers: {
          hasBorder: true
        }
      },
      {
        text: {
          id: 'text_2',
          string: 'Need help measuring? Please call your local store for more information.'
        }
      }
    ],
    footer: 'Next'
  },
  // Page 2
  {
    header: 'Step 1 of 5',
    sections: [
      {
        text: {
          id: 'text_3',
          string: 'Map Your Delivery Path',
          isTitle: true
        }
      },
      {
        text: {
          id: 'text_4',
          string: 'We want delivery and installation to go easy for you.'
        }
      },
      {
        text: {
          id: 'text_5',
          string: 'Our experts suggest:'
        },
        modifiers: {
          marginOverride: 2
        }
      },
      {
        list: {
          id: 'list_0',
          items: [
            'Find a route with the least obstacles from the delivery truck to the installation location.',
            'Measure your front door, interior doors, hallways and tight spaces along this path.',
            'Take note of the narrowest gap and tight turns.'
          ]
        }
      },
      {
        image: {
          id: 'image_2',
          src: LAUNDRY_ANIMATIONS.DELIVERY_PATH,
          alt: 'Delivery Path',
          size: '100%'
        }
      },
      {
        text: {
          id: 'text_6',
          string: 'This will help you know if your washer and dryer will clear the delivery path.'
        }
      },
      {
        tip: {
          id: 'tip_1',
          string: 'Consider removing doors if necessary prior to the delivery. Be prepared to remove furniture, decor and rugs along the path on delivery day.'
        },
        modifiers: {
          hasBorder: true
        }
      }
    ],
    footer: 'Next'
  },
  // Page 3
  {
    header: 'Step 2 of 5',
    sections: [
      {
        text: {
          id: 'text_7',
          string: 'Check Your Dryer Connection: Gas or Electric',
          isTitle: true
        }
      },
      {
        text: {
          id: 'text_8',
          string: 'All washers require a 3-prong 120-Volt outlet, but dryer connections vary. Use the information below to confirm your dryer power source.'
        }
      },
      {
        text: {
          id: 'text_9',
          boldString: 'Electric ',
          string: 'dryers require a 240-Volt outlet for three or four-prong electrical outlet withing 4 feet of your new appliance.',
        },
        modifiers: {
          marginOverride: 6
        }
      },
      {
        imageSeparator: {
          id: 'imageSeparator_0',
          separator: 'or',
          items: [
            {
              image: {
                id: 'image_3',
                src: LAUNDRY_IMAGES.THREE_PRONG,
                alt: '3-Prong 240-Volt',
                height: '100px',
                width: '100px',
                subHeader: '3-Prong 240-Volt'
              }
            },
            {
              image: {
                id: 'image_4',
                src: LAUNDRY_IMAGES.FOUR_PRONG,
                alt: '4-Prong 240-Volt',
                height: '100px',
                width: '100px',
                subHeader: '4-Prong 240-Volt'
              }
            },
          ]
        },
        modifiers: {
          marginOverride: 6,
          flexGroup: true,
        }
      },
      {
        text: {
          id: 'text_11',
          boldString: 'Gas ',
          string: 'dryers require a gas supply pipe with a shut-off valve directly behind the dryer and a standard 120-Volt outlet.'
        },
        modifiers: {
          marginOverride: 6
        }
      },
      {
        imageSeparator: {
          id: 'imageSeparator_1',
          separator: 'plus',
          items: [
            {
              image: {
                id: 'image_5',
                src: LAUNDRY_IMAGES.GAS,
                alt: 'Gas Valve',
                height: '80px',
                width: '143px',
                subHeader: 'Gas Valve'
              }
            },
            {
              image: {
                id: 'image_6',
                src: LAUNDRY_IMAGES.ELECTRIC,
                alt: '3-Prong 120-Volt',
                height: '65px',
                width: '70px',
                subHeader: '3-Prong 120-Volt',
              }
            },
          ]
        },
        modifiers: {
          marginOverride: 6,
          flexGroup: true,
        }
      },
      {
        text: {
          id: 'text_12',
          string: 'For clarity, the gas valve illustration is shown open. Always shut if off before maintenance, installation or inspection.'
        }
      },
      {
        tip: {
          id: 'tip_2',
          string: 'Look up the model of the current appliance to confirm the connection. Model numbers can usually be found on the door, back or side of appliances.'
        },
        modifiers: {
          hasBorder: true
        }
      },
      {
        text: {
          id: 'text_13',
          string: 'Make sure to purchase new required parts as old parts might void the warranty of your new appliance. Some parts come with the purchase of installation.'
        }
      }
    ],
    footer: 'Next'
  },
  // Page 4
  {
    header: 'Step 3 of 5',
    sections: [
      {
        text: {
          id: 'text_14',
          string: 'Measure the Width',
          isTitle: true
        }
      },
      {
        text: {
          id: 'text_15',
          string: 'Before you measure, consider the washer and dryer setup that works best for your space: Side-by-side or Stacked.'
        }
      },
      {
        tabs: {
          id: 'tabs_0',
          items: [
            {
              id: 'tab_0',
              label: 'Side-by-side',
              content: [
                {
                  sections: {
                    id: 'sections_2',
                    items: [
                      {
                        image: {
                          id: 'image_7',
                          src: LAUNDRY_IMAGES.SIDE_BY_SIDE,
                          alt: 'Side-by-side Washer Width',
                          size: '55%',
                          subHeader: 'Side-by-side'
                        },
                        modifiers: {
                          sideBySide: true
                        }
                      }
                    ]
                  },
                  modifiers: {
                    marginOverride: 6,
                    marginTopOverride: 2
                  }
                },
                {
                  text: {
                    id: 'text_16',
                    string: 'Now, measure the space where your washer and dryer will go. Take note of the width in two places:',
                  }
                },
                {
                  list: {
                    id: 'list_1',
                    items: [
                      'at the top of the wall or cabinet',
                      'at the floor level of the wall and cabinet',
                    ]
                  },
                  modifiers: {
                    marginOverride: 4
                  }
                },
                {
                  text: {
                    id: 'text_17',
                    string: 'Use the smallest measurement of the two.'
                  },
                  modifiers: {
                    marginOverride: 4
                  }
                },
                {
                  image: {
                    id: 'image_8',
                    src: LAUNDRY_ANIMATIONS.SIDE_BY_SIDE_WIDTH,
                    alt: 'Side-by-Side Measure Width Gif',
                    size: '100%',
                  },
                  modifiers: {
                    marginOverride: 4
                  }
                },
                {
                  tip: {
                    id: 'tip_3',
                    string: 'Minimize noise by leaving about 1 inch of space on each side and between your washer and dryer.',
                  },
                  modifiers: {
                    hasBorder: true,
                    marginOverride: 4
                  }
                },
                {
                  text: {
                    id: 'text_18',
                    string: 'Standard front load or top washers are 27 inches wide and standard front load dryers are 27-29 inches wide.',
                    isTiny: true
                  }
                },
              ]
            },
            {
              id: 'tab_1',
              label: 'Stacked',
              content: [
                {
                  text: {
                    id: 'text_19',
                    string: 'Stacked is only available for some front load sets and does not always work best with upper cabinets or low ceilings.',
                  },
                  modifiers: {
                    marginOverride: 6
                  }
                },
                {
                  sections: {
                    id: 'sections_3',
                    items: [
                      {
                        image: {
                          id: 'image_9',
                          src: LAUNDRY_IMAGES.STACKED,
                          alt: 'Stacked Dryer Width',
                          size: '30%',
                          subHeader: 'Stacked',
                          subSubHeader: '(Front Load)'
                        },
                        modifiers: {
                          stacked: true
                        }
                      }
                    ],
                  },
                  modifiers: {
                    marginOverride: 6
                  }
                },
                {
                  text: {
                    id: 'text_20',
                    string: 'Now, measure the space where your stacked washer and dryer will go, take note of the width in two places:'
                  },
                  modifiers: {
                    marginOverride: 2
                  }
                },
                {
                  list: {
                    id: 'list_1',
                    items: [
                      'at the top of the wall or cabinet',
                      'at the floor level of the wall and cabinet',
                    ]
                  },
                  modifiers: {
                    marginOverride: 4
                  }
                },
                {
                  text: {
                    id: 'text_21',
                    string: 'Use the smallest measurement of the two.'
                  },
                  modifiers: {
                    marginOverride: 4
                  }
                },
                {
                  image: {
                    id: 'image_10',
                    src: LAUNDRY_ANIMATIONS.STACKED_WIDTH,
                    alt: 'Stacked Measure Width Gif',
                    size: '100%',
                  },
                  modifiers: {
                    marginOverride: 4
                  }
                },
                {
                  tip: {
                    id: 'tip_4',
                    string: 'Minimize noise by leaving about 1 inch of space on each side of your washer and dryer.',
                  },
                  modifiers: {
                    hasBorder: true,
                    marginOverride: 4
                  }
                },
                {
                  text: {
                    id: 'text_22',
                    string: 'Standard stackable models are 30-34 inches wide.',
                    isTiny: true
                  }
                }
              ]
            }
          ]
        }
      }
    ],
    footer: 'Next'
  },
  // Page 5
  {
    header: 'Step 4 of 5',
    sections: [
      {
        text: {
          id: 'text_23',
          string: 'Measure the Height',
          isTitle: true
        }
      },
      {
        text: {
          id: 'text_24',
          string: 'Before you measure, consider the washer and dryer setup that works best for your space: Side-by-side or Stacked.'
        }
      },
      {
        tabs: {
          id: 'tabs_1',
          items: [
            {
              id: 'tab_2',
              label: 'Side-by-side',
              content: [
                {
                  sections: {
                    id: 'sections_4',
                    items: [
                      {
                        image: {
                          id: 'image_11',
                          src: LAUNDRY_IMAGES.SIDE_BY_SIDE_WITH_PEDESTALS,
                          alt: 'Side-by-side Washer Height',
                          size: '55%',
                          subHeader: 'Side-by-side',
                          subSubHeader: '(Pedestals Sold Separately)'
                        },
                        modifiers: {
                          sideBySide: true,
                        }
                      }
                    ]
                  },
                  modifiers: {
                    marginOverride: 6,
                    marginTopOverride: 2
                  }
                },
                {
                  text: {
                    id: 'text_25',
                    string: 'A few things to keep in mind as you measure:',
                  }
                },
                {
                  list: {
                    id: 'list_2',
                    items: [
                      'Pedestals increase the total height of each appliance by 10 to 16 inches.',
                      'Top-load machines require an additional 20 to 24 inches of height to fully open the door.'
                    ]
                  },
                  modifiers: {
                    marginOverride: 4
                  }
                },
                {
                  tip: {
                    id: 'tip_5',
                    string: 'Different brands and models offer their own washer and dryer pedestals or you can get a universal option. Pedestals cannot be used when stacking your washer and dryer.'
                  },
                  modifiers: {
                    hasBorder: true,
                    marginOverride: 4
                  }
                },
                {
                  image: {
                    id: 'image_12',
                    src: LAUNDRY_ANIMATIONS.SIDE_VIEW,
                    alt: 'Washer and Dryer Side-by-Side Door Measure Height',
                    size: '100%',
                  },
                  modifiers: {
                    marginOverride: 6
                  }
                },
                {
                  text: {
                    id: 'text_26',
                    string: 'Measure from the floor to the bottom of any cabinet or counter top in both the front and back of the installation space.'
                  },
                  modifiers: {
                    marginOverride: 4
                  }
                },
                {
                  text: {
                    id: 'text_27',
                    string: 'Use the shorter of these two measurements for the overall height needed.'
                  },
                  modifiers: {
                    marginOverride: 4
                  }
                },
                {
                  image: {
                    id: 'image_13',
                    src: LAUNDRY_ANIMATIONS.SIDE_BY_SIDE_HEIGHT,
                    alt: 'Washer and Dryer Measure Height',
                    size: '100%',
                  },
                  modifiers: {
                    marginOverride: 4
                  }
                },
                {
                  text: {
                    id: 'text_28',
                    string: 'Standard front load washers are 33-39 inches in height, standard front load dryers are 36 inches in height and standard top load washers are 36-42 inches in height.',
                    isTiny: true
                  }
                }
              ]
            },
            {
              id: 'tab_3',
              label: 'Stacked',
              content: [
                {
                  text: {
                    id: 'text_29',
                    string: 'Stacked units are only available for front-load sets and do not leave room for upper cabinets above.',
                  },
                  modifiers: {
                    marginOverride: 6
                  }
                },
                {
                  sections: {
                    id: 'sections_5',
                    items: [
                      {
                        image: {
                          id: 'image_14',
                          src: LAUNDRY_IMAGES.STACKED,
                          alt: 'Stacked Dryer Height',
                          size: '30%',
                          subHeader: 'Stacked',
                          subSubHeader: '(Front Load)'
                        },
                        modifiers: {
                          stacked: true
                        }
                      }
                    ]
                  },
                  modifiers: {
                    marginOverride: 4
                  }
                },
                {
                  text: {
                    id: 'text_30',
                    string: 'Measure from the floor to the ceiling. Do this in both the front and back of the space.'
                  },
                  modifiers: {
                    marginOverride: 4
                  }
                },
                {
                  text: {
                    id: 'text_31',
                    string: 'Use the shorter of these two measurements for the overall height needed.'
                  },
                  modifiers: {
                    marginOverride: 4
                  }
                },
                {
                  image: {
                    id: 'image_15',
                    src: LAUNDRY_ANIMATIONS.STACKED_HEIGHT,
                    alt: 'Washer and Dryer Stacked Measure Height Gif',
                    size: '100%',
                  },
                  modifiers: {
                    marginOverride: 4
                  }
                },
                {
                  tip: {
                    id: 'tip_6',
                    string: 'Unless your washer and dryer is a laundry center, the stacking kit is often sold separately.'
                  },
                  modifiers: {
                    hasBorder: true,
                    marginOverride: 4
                  }
                },
                {
                  text: {
                    id: 'text_32',
                    string: 'Standard stackable washer and dryers are 75 inches in height.',
                    isTiny: true
                  }
                }
              ]
            }
          ]
        }
      }
    ],
    footer: 'Next'
  },
  // Page 6
  {
    header: 'Step 5 of 5',
    sections: [
      {
        text: {
          id: 'text_33',
          string: 'Decide on Depth',
          isTitle: true
        }
      },
      {
        text: {
          id: 'text_34',
          string: 'In addition to the appliance\'s depth, ensure an extra 6 inches between the wall and the back for floor trim, cords, vents and water hookups.'
        }
      },
      {
        image: {
          id: 'image_16',
          src: LAUNDRY_ANIMATIONS.DEPTH,
          alt: 'Washer and Dryer Stacked Measure Depth',
          size: '100%',
        }
      },
      {
        text: {
          id: 'text_35',
          string: 'Allow for a minimum open-door clearance of 20 inches for front-load appliances. An additional 4 feet will make loading and unloading easier.'
        }
      },
      {
        image: {
          id: 'image_17',
          src: LAUNDRY_ANIMATIONS.SWING_DEPTH,
          alt: 'Washer and Dryer Stacked Measure Depth Swing Gif',
          size: '100%',
        }
      },
      {
        text: {
          id: 'text_36',
          string: 'Refer to your manual-door swing directions can vary. Some dryer doors are reversible and can be adjusted during installation.'
        },
        modifiers: {
          marginOverride: 4
        }
      },
      {
        tip: {
          id: 'tip_7',
          string: 'For small or tight spaces, consider compact washing machines and dryers.'
        },
        modifiers: {
          hasBorder: true,
          marginOverride: 6
        }
      },
      {
        text: {
          id: 'text_37',
          string: 'For a more detailed measureing guide visit ',
          linkString: 'Washer & Dryer Dimensions.',
          linkUrl: 'https://www.homedepot.com/c/ab/washer-and-dryer-dimensions/9ba683603be9fa5395fab90117c9b20e'
        }
      }
    ],
    footer: 'Done'
  }
];

export const ONLINE_STORE_ID = '8119';
